import { useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { paymentSaveApi } from "../CustomerCRUD";
import { toast } from "react-toastify";
import { clearCart } from "../../../store/cartSlice";
import { useDispatch } from "react-redux";

const PaymentPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState(1);
  const [paying, setPaying] = useState(false);

  const methods = [
    // { id: 1, name: "CASH" },
    { id: 2, name: "UPI" },
    { id: 3, name: "CARD" },
    { id: 4, name: "NET BANKING" },
  ];

  useEffect(() => {
    const storedOrder = localStorage.getItem("order");
    setOrder(storedOrder ? JSON.parse(storedOrder) : null);
    setLoading(false);
  }, []);

  const handlePayment = async () => {
    if (!order) return;
    setPaying(true);
    try {
      const res = await paymentSaveApi(
        parseInt(id),
        paymentMethod,
        order.subTotal
      );

      if (res.data.isSuccess) {
        toast.success("Payment saved successfully");
        // navigate(`/order-confirmation/${orderID}`);

        // localStorage.removeItem("customer");
        // localStorage.removeItem("checkoutAddress");
        localStorage.removeItem("order");

        // Clear Redux cart
        dispatch(clearCart());
        navigate("/member/dashboard", { replace: true });
      } else {
        alert("Payment failed, please try again.");
      }
    } catch (err) {
      alert("Error processing payment.");
    } finally {
      setPaying(false);
    }
  };

  // if (loading || !order) {
  //   return <p className="text-center py-10">Loading order...</p>;
  // }

  return (
    <div className="max-w-4xl mx-auto py-6 px-4">
      <h5 className="fs-5 mb-6 text-center text-dark">Payment</h5>

      <Card className="rounded-2xl mb-4">
        <div className="p-6">
          <h6
            className="text-xl font-semibold mb-4"
            style={{ color: "#FF4F00" }}
          >
            Order Summary
          </h6>
          <p>
            <strong>Sub Total:</strong> ₹{order.subTotal}
          </p>
          {/* <p className="text-lg font-bold mt-2">
            <strong>Final Total:</strong> ₹{order.finalTotal}
          </p> */}
        </div>
      </Card>

      <Card className="rounded-2xl mb-4">
        <div className="p-3">
          <p className="fs-6 mb-3">Choose Payment Method</p>
          <div className="space-y-2">
            {methods.map((method) => (
              <label
                key={method.id}
                className={`flex items-center p-2 border rounded-lg cursor-pointer ${
                  paymentMethod === method.id
                    ? "bg-blue-100 border-blue-500"
                    : "border-gray-300"
                }`}
              >
                <input
                  type="radio"
                  name="paymentMethod"
                  value={method.id}
                  checked={paymentMethod === method.id}
                  onChange={(e) => setPaymentMethod(Number(e.target.value))}
                  className="mr-2"
                />
                {method.name}
              </label>
            ))}
          </div>
        </div>
      </Card>

      <div className="text-center">
        <Button
          onClick={handlePayment}
          disabled={paying}
          className="w-40 py-2 text-lg rounded-xl shadow-md"
          style={{
            backgroundColor: "#FF4F00",
          }}
        >
          {paying ? "Processing..." : `Pay ₹${order.finalTotal}`}
        </Button>
      </div>
    </div>
  );
};

export default PaymentPage;
